"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyLookup = void 0;
var domain_1 = require("@genoa/domain");
exports.propertyLookup = {
    pmc: {
        external_pmc_id: 'flex-dev',
        id: 5,
        name: 'My Property',
    },
    property: {
        created_at: '2023-11-29',
        address_line_1: '123 Main St',
        address_line_2: '1b',
        city: 'Chicago',
        external_property_id: 'flex01',
        id: 35,
        identity_biller_id: 2040,
        integration_type: domain_1.IntegrationType.YARDI,
        biller_integration_type: 'YARDI',
        latitude: 41.8500412,
        longitude: -87.6273253,
        name: 'Flex Property',
        public_id: 'bv2ae5d405c9729421c8527f72b83be4680',
        state: 'IL',
        status: domain_1.BillerPropertyStatus.ACTIVE,
        updated_at: '2023-11-29',
        zip: '60610',
    },
    resident: {
        email: 'john@smith.com',
        external_id: 't12345',
        first_name: 'John',
        label: 'Unit 101',
        last_name: 'Smith',
        phone: '8008000000',
        rent_amount_cents: 200000,
        unit: '1b',
    },
    eligibility: {
        bp_start_date: '2024-10-31',
        bp_end_date: '2024-11-15',
        eligible: true,
        failure_code: domain_1.EmbedPayNowEligibilityFailureCode.SIGNUP,
    },
};
